export default {
  path: "/user/cpa/kermeses",
  component: () => import("@/views/user/cpa/kermeses/KermesesLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "kermeses-dashboard",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesesDashboard.vue"),
    },
    {
      path: "config",
      name: "kermeses-config",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesesConfigView.vue"),
    },
    {
      path: "nueva",
      name: "kermeses-nueva",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesseEditorView.vue"),
    },
    {
      path: ":kermesseId",
      name: "kermeses-detalle",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesseEditorView.vue"),
      props: true,
    },
    {
      path: ":kermesseId/cursos",
      name: "kermeses-cursos",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesseCoursesView.vue"),
      props: true,
    },
    {
      path: ":kermesseId/productos",
      name: "kermeses-productos",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesseProductsView.vue"),
      props: true,
    },
    {
      path: ":kermesseId/comprobantes",
      name: "kermeses-comprobantes",
      component: () =>
        import("@/views/user/cpa/kermeses/KermesseReceiptsView.vue"),
      props: true,
    },
  ],
};
